module.exports = "images/meet-the-mad-scientists_poster@2x.jpg";